var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jyp1240sqa",
    d: "M10.64 7c1.108 0 1.996-.893 1.996-2s-.888-2-1.996-2c-1.109 0-2.004.893-2.004 2s.895 2 2.004 2zM5.549 7c1.108 0 1.996-.893 1.996-2S6.657 3 5.55 3c-1.109 0-2.004.893-2.004 2S4.44 7 5.55 7zm-.094 1.571c-1.483 0-4.455.669-4.455 2V12h8.91v-1.429c0-1.331-2.973-2-4.455-2zm5.09 0c-.184 0-.394.012-.617.029.738.48 1.254 1.126 1.254 1.971V12H15v-1.429c0-1.331-2.972-2-4.455-2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-310 -479) translate(288 245) translate(16 230.703) translate(6 4.09)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hgomvwlmwb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jyp1240sqa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#00A2EB",
    mask: "url(#hgomvwlmwb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeam);
export default __webpack_public_path__ + "static/media/icon-team.a6cb752db3344a5d233dcf912c027c2f.svg";
export { ForwardRef as ReactComponent };